import { render } from "./TableSort.vue?vue&type=template&id=710ea10c&scoped=true&ts=true"
import script from "./TableSort.vue?vue&type=script&lang=ts"
export * from "./TableSort.vue?vue&type=script&lang=ts"

import "./TableSort.vue?vue&type=style&index=0&id=710ea10c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-710ea10c"]])

export default __exports__